// Central site configuration & content (no fabricated stats / testimonials / logos)

export const ASSETS = {
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_asai-core/artifacts/91eihqrm_ASAI%20LOGO.png",
  // Founder photography (user-provided)
  founder:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_asai-core/artifacts/om8ky3i5_Founder_Image_2.png",
  founderDesk:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_asai-core/artifacts/k835av8b_Founder_Image1.png",
  team: {
    surendra:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_asai-core/artifacts/1f3ba85463523ba2_Surender%20Mohan%20Sir.png",
    himanshi:
      "https://customer-assets-jt897jd0.emergentagent.net/wingman/6e26ab01-4433-4f9e-bcec-c80830a73e9d/attachments/7d52386c6d0342faa139c66b0b4f0f22_Himanshi Kaushik.jpeg",
    mukul:
      "https://customer-assets-jt897jd0.emergentagent.net/wingman/6e26ab01-4433-4f9e-bcec-c80830a73e9d/attachments/d95a4083efe34b21b9846f97056cc337_Mukul.jpeg",
    deepanshu:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_asai-core/artifacts/9f1ac5d1bbb15d60_Deepanshu%20Sharma.png",
    mukesh:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_asai-core/artifacts/9c7514e8edce5029_Mukesh%20Jaiswal.PNG",
  },
  heroAbstract:
    "https://images.pexels.com/photos/14314636/pexels-photo-14314636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  robotic:
    "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  students:
    "https://images.pexels.com/photos/7988744/pexels-photo-7988744.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  org: "ASAI – Atmasamman School of AI",
  initiative: "An Initiative of Atmasamman Group",
  unit: "A Unit Of Atmasamman Pvt. Ltd.",
  phone: "+91 78300 60800",
  phoneRaw: "917830060800",
  email: "info@atmasammanschoolofai.com",
  website: "www.atmasammanschoolofai.com",
  address: [
    "Plot No. 98, First Floor,",
    "Above Reliance Smart Point,",
    "Opposite DAV Degree College, DAV Tiraha,",
    "Shivpuri, Bulandshahr – 203001,",
    "Uttar Pradesh, India",
  ],
};

export const FOUNDER = {
  name: "Pankaj Sharma",
  titles: ["Founder & CEO – ASAI", "Founder – Atmasamman Group"],
  positioning:
    "Technology Consultant | AI and Digital Payments Expert | Corporate Trainer | Career Mentor | Industry Speaker | Career Counsellor",
  profile:
    "Technology Consultant, AI and Digital Payments Expert, Corporate Trainer, Career Mentor, Industry Speaker, and Career Counsellor with 15+ years of experience.",
  fullProfile:
    "Pankaj Sharma is a technology professional with 15+ years of experience in Enterprise Applications, Digital Payments, Cloud Technologies, Artificial Intelligence, and Business-Critical Systems.",
  mission:
    "To bridge the gap between academic education and industry expectations through practical learning, emerging technologies, mentorship, and career readiness.",
  linkedin: "https://www.linkedin.com/in/pankajsharmalead",
  experience: [
    "IBM Delivery Environment – Idea Telecommunications Project",
    "Tech Mahindra Delivery Environment",
    "BMC Software",
    "Mastercard",
    "Technology Consulting – Macquarie Bank Project",
    "Technology Consulting – Unilever Project",
    "EY",
  ],
  education: [
    { title: "Executive MBA", place: "SIBM Pune" },
    { title: "Bachelor of Computer Applications", place: "DPBS PG College, Anupshahr" },
    { title: "AI and Machine Learning Certification", place: "SP Jain Institute of Management and Research, Mumbai" },
  ],
};

export const ABOUT = {
  intro:
    "ASAI – Atmasamman School of AI is an industry-focused education, internship and career-development platform created to bridge the gap between academic education and industry expectations.",
  skills: [
    "Artificial Intelligence",
    "Generative AI",
    "Machine Learning",
    "Python",
    "Cloud Computing",
    "DevOps",
    "SQL",
    "Linux",
    "UPI and Digital Payments",
    "Software Development",
    "Career Readiness",
  ],
  vision:
    "To build a generation of industry-ready professionals who can confidently apply Artificial Intelligence and emerging technologies to real-world problems.",
  mission:
    "To bridge the gap between academic education and industry expectations through practical learning, emerging technologies, mentorship and career readiness.",
  different: [
    { title: "Industry-Oriented, Not Theoretical", text: "Learning is mapped to real roles and the skills the industry expects — not exam-focused rote study." },
    { title: "Practical & Project-Driven", text: "Live projects, hands-on labs and applied work sit at the centre of every program." },
    { title: "Mentorship That Matters", text: "Guidance from experienced practitioners, with reviews and real feedback." },
    { title: "Career-First Approach", text: "Resume, LinkedIn, interview readiness and career support are built into the journey." },
  ],
  methodology: [
    { step: "01", title: "Learn", text: "Structured, industry-aligned concepts explained clearly and practically." },
    { step: "02", title: "Apply", text: "Hands-on labs and assignments that reinforce every concept." },
    { step: "03", title: "Build", text: "Live projects and a capstone to turn skills into a real portfolio." },
    { step: "04", title: "Prepare", text: "Interview preparation, soft skills and career support for the next step." },
  ],
  whoWeSupport: [
    { title: "Students", text: "Build a strong, industry-ready foundation in AI and modern technologies." },
    { title: "Graduates", text: "Convert your degree into practical, employable skills." },
    { title: "Working Professionals", text: "Upskill or transition into AI, cloud and data roles." },
    { title: "Colleges & Institutions", text: "Bring applied AI training and expert sessions to your campus." },
  ],
  collaboration:
    "ASAI collaborates with colleges and institutions to deliver industry-oriented training, expert sessions and internship pathways for students — helping bridge the classroom-to-career gap at scale.",
  careerApproach: [
    "Resume and LinkedIn development",
    "Mock interviews and interview readiness",
    "Communication and soft-skills training",
    "Career counselling and guidance",
    "Placement assistance (no guaranteed placement)",
  ],
};

export const TEAM = [
  {
    name: "Mr. Surendra Mohan",
    role: "Senior Consultant – Strategy & Growth",
    photo: ASSETS.team.surendra,
    experience: "39+ Years",
    previousRole: "Chief Manager (Scale IV), Punjab National Bank",
    desc: "An experienced professional specializing in strategic planning, business growth, leadership and institutional partnerships. At ASAI, he supports senior management decisions, coordinates with colleges, universities and companies, and contributes to student career counselling and organizational growth.",
  },
  { name: "Himanshi Kaushik", role: "Sr. Coordinator / IT", photo: ASSETS.team.himanshi, desc: "Coordinates IT operations and day-to-day program delivery at ASAI." },
  { name: "Mukul", role: "Operations Executive / IT", photo: ASSETS.team.mukul, desc: "Supports IT operations and smooth execution of ASAI programs." },
  { name: "Deepanshu Sharma", role: "Operations Executive / IT", photo: ASSETS.team.deepanshu, desc: "Supports IT operations and smooth execution of ASAI programs." },
  { name: "Mukesh Jaiswal", role: "Sr. Social Media Executive", photo: ASSETS.team.mukesh, desc: "Responsible for social media management, content creation, digital engagement, brand visibility and online growth at ASAI." },
];

// Official ASAI social media accounts — single source of truth.
// Update these URLs here to change them everywhere (footer + floating widget).
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/atmasammanschoolofai/",
  youtube: "https://www.youtube.com/@AtmasammanSchoolofai-ASAI",
  linkedin: "https://www.linkedin.com/company/144883959/",
  facebook: "https://www.facebook.com/profile.php?id=61586021284714",
};

export const SOCIALS = [
  { label: "LinkedIn", icon: "Linkedin", href: SOCIAL_LINKS.linkedin },
  { label: "Instagram", icon: "Instagram", href: SOCIAL_LINKS.instagram },
  { label: "YouTube", icon: "Youtube", href: SOCIAL_LINKS.youtube },
  { label: "Facebook", icon: "Facebook", href: SOCIAL_LINKS.facebook },
];

export const WHATSAPP = {
  number: "917830060800",
  message:
    "Hello ASAI Team, I would like to know more about your courses and internship programs.",
  link:
    "https://wa.me/917830060800?text=" +
    encodeURIComponent(
      "Hello ASAI Team, I would like to know more about your courses and internship programs."
    ),
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Courses", to: "/courses", dropdown: "courses" },
  { label: "Colleges", to: "/college-partnerships" },
  { label: "Our Results", to: "/our-results" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_LINE = [
  "Industry-Oriented Learning",
  "Live Projects",
  "Expert Mentorship",
  "Internship Opportunities",
  "Career Support",
];

export const HERO_TAGS = [
  "Artificial Intelligence",
  "Generative AI",
  "Machine Learning",
  "Cloud Computing",
  "DevOps",
  "UPI & Digital Payments",
  "SQL",
  "Linux",
  "Software Development",
];

// Section 2 — Trust & highlights (no fake counts / placement %)
export const HIGHLIGHTS = [
  { icon: "Award", title: "15+ Years of Industry Experience" },
  { icon: "Briefcase", title: "Industry-Oriented Programs" },
  { icon: "Wrench", title: "Practical Learning" },
  { icon: "Rocket", title: "Live Projects" },
  { icon: "GraduationCap", title: "College Collaborations" },
  { icon: "MonitorSmartphone", title: "Online and Offline Training" },
];

// Section 4 — Why choose ASAI (icon cards)
export const WHY_CHOOSE = [
  { icon: "BookOpen", title: "Industry-Designed Curriculum" },
  { icon: "Video", title: "Live Interactive Classes" },
  { icon: "Wrench", title: "Hands-On Training" },
  { icon: "FolderKanban", title: "Real-World Projects" },
  { icon: "Users", title: "Expert Mentorship" },
  { icon: "Rocket", title: "Internship Opportunities" },
  { icon: "FileText", title: "Resume and LinkedIn Guidance" },
  { icon: "MessagesSquare", title: "Mock Interviews" },
  { icon: "Compass", title: "Career Counselling" },
  { icon: "MonitorSmartphone", title: "Online and Offline Learning" },
];

// Section 6 — Expert session topics for colleges/universities
export const EXPERT_TOPICS = [
  "Artificial Intelligence and Machine Learning",
  "Generative AI",
  "UPI and Digital Payments",
  "Cloud and DevOps",
  "Emerging Technology Careers",
  "Career and Interview Readiness",
];

// Section 7 — Student journey
export const JOURNEY = [
  "Enquiry",
  "Counselling",
  "Program Selection",
  "Practical Learning",
  "Live Project",
  "Certification",
  "Interview Preparation",
  "Career Support",
];

export const MARQUEE_WORDS = [
  "Applied AI",
  "Machine Learning",
  "Data Science",
  "Generative AI",
  "Career Readiness",
  "Industry Internships",
  "Prompt Engineering",
  "Deep Learning",
];

// Retained for /programs page + About page
export const PROGRAMS = [
  {
    slug: "applied-ai-foundations",
    title: "Applied AI Foundations",
    level: "Beginner",
    duration: "12 Weeks",
    summary:
      "Build a strong base in Python, data handling and the core intuition behind modern AI systems.",
    focus: ["Python", "Data Handling", "AI Intuition"],
  },
  {
    slug: "machine-learning-engineering",
    title: "Machine Learning Engineering",
    level: "Intermediate",
    duration: "16 Weeks",
    summary:
      "Design, train and deploy machine learning models with real project workflows used in industry.",
    focus: ["Supervised ML", "Model Deployment", "Pipelines"],
  },
  {
    slug: "generative-ai-llms",
    title: "Generative AI & LLMs",
    level: "Advanced",
    duration: "10 Weeks",
    summary:
      "Work hands-on with large language models, prompt engineering and building AI-powered applications.",
    focus: ["LLMs", "Prompt Engineering", "AI Apps"],
  },
  {
    slug: "data-science-analytics",
    title: "Data Science & Analytics",
    level: "Intermediate",
    duration: "14 Weeks",
    summary:
      "Turn raw data into decisions with statistics, visualisation and practical analytics tooling.",
    focus: ["Statistics", "Visualisation", "Analytics"],
  },
];

export const FEATURES = [
  {
    icon: "Briefcase",
    title: "Industry-Focused Curriculum",
    text: "Every module is mapped to real roles and skills employers actively hire for.",
  },
  {
    icon: "Users",
    title: "Mentor-Led Learning",
    text: "Guided sessions and reviews with practitioners, not pre-recorded monologues.",
  },
  {
    icon: "Rocket",
    title: "Internship Pathways",
    text: "Structured routes from classroom concepts to hands-on internship experience.",
  },
  {
    icon: "GraduationCap",
    title: "College Partnerships",
    text: "Collaborations that bring applied AI training directly onto campus.",
  },
  {
    icon: "Compass",
    title: "Career Development",
    text: "Portfolio, interview and positioning support built into the journey.",
  },
  {
    icon: "Sparkles",
    title: "Expert Sessions",
    text: "Focused sessions with domain experts on current, applied AI topics.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Skills that matter",
    text: "We teach applied AI the way industry actually uses it — practical, current and outcome-driven.",
  },
  {
    no: "02",
    title: "Learning by building",
    text: "Real projects and internships replace passive lectures, so knowledge turns into capability.",
  },
  {
    no: "03",
    title: "Access with intent",
    text: "From students to professionals to campuses, we design pathways for every kind of learner.",
  },
  {
    no: "04",
    title: "Careers, not certificates",
    text: "The goal is not just completion — it is readiness to lead in an AI-driven world.",
  },
];

export const AUDIENCES = [
  { title: "Students", text: "Launch an AI career with structured, industry-ready foundations." },
  { title: "Professionals", text: "Upskill into AI roles with applied, mentor-led programs." },
  { title: "Colleges", text: "Bring applied AI training and internships onto your campus." },
  { title: "Corporate Partners", text: "Collaborate on talent, training and AI capability building." },
];

/*
 * ASAI Careers — vacancies.
 * Edit this array to add, update or remove openings. Each entry needs a
 * stable `id` so admin dashboards can group applications by position.
 */
export const CAREERS = [
  {
    id: "devops-trainer",
    title: "DevOps Trainer",
    summary: "AWS, Linux, Docker, Jenkins & CI/CD",
    description:
      "Deliver hands-on sessions on AWS, Linux, Docker, Jenkins and CI/CD pipelines. Mentor interns through real deployments and build job-ready DevOps engineers.",
    experience: "2+ years",
    skills: ["AWS", "Linux", "Docker", "Jenkins", "CI/CD"],
    type: "Full-time",
    location: "Bulandshahr / Hybrid",
    icon: "Server",
  },
  {
    id: "python-trainer",
    title: "Python Trainer",
    summary: "Python Programming & Practical Training",
    description:
      "Teach Python from fundamentals to applied programming for AI, data and backend workflows. Design labs, assignments and project reviews.",
    experience: "2+ years",
    skills: ["Python", "OOP", "APIs", "Problem Solving"],
    type: "Full-time",
    location: "Bulandshahr / Hybrid",
    icon: "Code2",
  },
  {
    id: "data-science-trainer",
    title: "Data Science Trainer",
    summary: "Data Science, AI & Machine Learning",
    description:
      "Teach Data Science, AI and Machine Learning with real datasets. Guide learners through modelling, evaluation and end-to-end project delivery.",
    experience: "3+ years",
    skills: ["Python", "ML", "Statistics", "scikit-learn", "Pandas"],
    type: "Full-time",
    location: "Bulandshahr / Hybrid",
    icon: "BrainCircuit",
  },
  {
    id: "coordinator",
    title: "Coordinator",
    summary: "Student Coordination & Office Operations",
    description:
      "Own student onboarding, batch coordination, attendance, communication and smooth day-to-day office operations.",
    experience: "1+ years",
    skills: ["Coordination", "Communication", "MS Office", "CRM"],
    type: "Full-time",
    location: "Bulandshahr",
    icon: "Users",
  },
  {
    id: "hr-manager",
    title: "HR Manager",
    summary: "Recruitment, HR Operations & Team Management",
    description:
      "Lead recruitment, onboarding, HR operations, performance reviews and team culture across the ASAI organisation.",
    experience: "3+ years",
    skills: ["Recruitment", "HR Ops", "People Management", "Policies"],
    type: "Full-time",
    location: "Bulandshahr",
    icon: "Briefcase",
  },
];
